<template>
  <section>
    <header-prismic />
    <div class="screen" :class="{ 'd-none': this.loader }">
        <div class="loader-card" id="loading">
            <img width="200" :src="loader_image">
        </div>
    </div>
      <div class="login-page ct-form">
        <div class="ct-inner-form">
          <h2>Login</h2>
          <form @submit.prevent="submitFormLogin" v-if="!formSubmitted">
            <div class="row m-0">
              <div class="col-md-6 ps-0">
                <div class="form-group">
                  <label class="form-label">Email</label>
                  <input v-model="email" type="email" class="form-control" required/>
                </div>
              </div>
              <div class="col-md-6 pe-0">
                <div class="form-group">
                  <label class="form-label">Password</label>
                  <input v-model="password" type="password" class="form-control" minlength="6" required/>
                  <router-link to="/recover-password"> Recover Password </router-link>
                </div>
                <span class="text-danger" v-if="errors">{{ errors[0] }}</span>
              </div>
            </div>
            <div class="button-group">
              <button type="submit" class="ct-button"> Sign In </button>
              <router-link to="/signup"> Create account </router-link>
            </div>
          </form>
        </div>
      </div>
    <footer-prismic />
  </section>
</template>

<script>
// imports for all components
import HeaderPrismic from '../../components/HeaderPrismic.vue'
import FooterPrismic from '../../components/FooterPrismic.vue'

export default {
  name: 'login',
  components: {
    HeaderPrismic,
    FooterPrismic,
  },
  data() {
    return {
      auth: false,
      email: "",
      password: "",
      formSubmitted: false,
      errors: {},
      loader:true,

    };
  },
  methods: {
    async submitFormLogin () {
      this.loader = false;

      let data = new FormData();
      data.append('email', this.email);
      data.append('password', this.password);

      this.$store.dispatch("LOGIN", data)
        .then((response) => {
            if(response){
              this.loader = true;

              this.$router.push({
                  name: 'account'
              });
              this.$toast.success(`You have Login successfully !!`);
            }
        }).catch((err) => {
          console.log("err", err);
          this.loader = true;

            // console.log(err.response.data.errors)
            if(err.response.data.error == "Unauthorised"){
              this.$toast.error(`Unauthorized`);
            }
            this.errors = err.response.data.errors;
      });
    }
  },
  computed: {
      loader_image() {
          return '/assets/image/loader.png';
      },
  },
}
</script>

<style>
.screen {
    z-index: 9999;
    display: flex;
    align-items: center;
    background-color: #ffffff29;
    backdrop-filter: blur(4px);
    position: absolute;
    width: 100%;
    height: 100%;
}
.loader-card {
    width: 100%;
    text-align: center;
}
.main-inner-header nav.navbar .collapse a.nav-link {
  color: #222;
}

.main-inner-header nav.navbar .collapse a.nav-link.dropdown-toggle::after {
  filter: none;
}

.main-inner-header nav.navbar .right-panel .Cart .icon path {
  fill: #000;
}

.main-inner-header nav.navbar .right-panel .icon path {
  stroke: #000;
}

.main-inner-header nav.navbar a.logo img.normal-logo {
  display: none;
}

.main-inner-header .header-botton nav.navbar a.logo img.sticky-logo {
  display: block;
}

.ct-form {
  text-align: left;
  margin: 80px 0;
  padding: 100px 0;
}

.ct-inner-form {
  max-width: 860px;
  margin: 0 auto;
  padding: 0 15px;
}

.ct-inner-form h2 {
  font-size: 42px;
  font-weight: 400;
  margin-bottom: 35px;
  color: #222;
}

.ct-inner-form .row>div {
  padding: 0 5px;
}

.ct-inner-form .form-group label.form-label {
  font-size: 14px;
  margin-bottom: 10px;
  color: #222;
}

.ct-inner-form .form-group input.form-control {
  font-size: 17px;
  min-height: 42px;
  border-radius: 0;
  border-color: #e4e4e4;
}

.ct-inner-form .form-group input.form-control:focus {
  box-shadow: none;
}

.ct-inner-form a {
  font-size: 14px;
  color: #222;
}

.ct-inner-form .form-group a {
  margin: 8px 0;
  display: inline-block;
}

.ct-inner-form .button-group {
  display: flex;
  flex-direction: column;
}

.ct-inner-form .button-group button.ct-button {
  display: inline-block;
  position: relative;
  font-weight: 400;
  font-size: 15px;
  transition: opacity .2s ease-in-out;
  cursor: pointer;
  padding: 10px 30px;
  line-height: 22px;
  text-transform: capitalize;
  text-align: center;
  text-decoration: none !important;
  letter-spacing: 0px;
  background-color: #ffffff;
  color: #000;
  border: 1px solid #000;
  border-radius: 0;
  margin-right: auto;
}

.ct-inner-form .button-group a {
  display: inline-block;
  margin: 8px 0;
}
.ct-inner-form p {
    margin-bottom: 20px;
    font-size: 14px;
}
@media(max-width: 767px) {
  .ct-inner-form .row>div {
    padding: 0;
  }
  .ct-inner-form h2{
    font-size: 30px;
  }
}
</style>
